// @flow
import React, { useState } from 'react';
import { FloatingPortal, offset, safePolygon } from '@floating-ui/react';
import Menu from 'material-ui/Menu/Menu';
import MenuItem from 'material-ui/MenuItem';
import { useFloating, useHover, useInteractions } from '@floating-ui/react';

export const NestingMenuItem = props => {
	const { children, menuItems, ...other } = props;
	const [isOpen, setIsOpen] = useState(false);

	const { refs, floatingStyles, context } = useFloating({
		placement: 'right-start',
		strategy: 'fixed',
		middleware: [offset(10)],
		open: isOpen,
		onOpenChange: setIsOpen,
	});

	const hover = useHover(context, {
		enabled: true,
		delay: { open: 75 },
		handleClose: safePolygon({ blockPointerEvents: true }),
	});
	const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

	return (
		<MenuItem {...other} style={{ padding: 0 }}>
			<div style={{ position: 'absolute', right: 0, left: 0, top: 0, bottom: 0 }} ref={refs.setReference} {...getReferenceProps()} />
			{isOpen && (
				<FloatingPortal>
					<div className="floating" ref={refs.setFloating} style={{ ...floatingStyles, zIndex: 2000 }} {...getFloatingProps()}>
						<Menu
							listStyle={{
								border: '1px solid #eee',
								boxShadow: '0px_4px_4px_rgba(217,227,235,0.25)',
								backgroundColor: '#fff',
								marginBottom: 0,
								paddingBottom: 0,
								paddingTop: 0,
							}}
						>
							{menuItems}
						</Menu>
					</div>
				</FloatingPortal>
			)}
		</MenuItem>
	);
};

export default NestingMenuItem;



// WEBPACK FOOTER //
// src/components/nested-menu/nesting-menu-item.jsx